import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询列表
export function query(requestBody) {
  return request({
    url: URL.finance.accountingEntry.query,
    method: 'post',
    data: requestBody
  })
}

// 明细账_2: 多币种
export function getAccountingEntriesForFlowChart2ByMultiCurrency(requestBody) {
  return request({
    url: URL.finance.accountingEntry.getAccountingEntriesForFlowChart2ByMultiCurrency,
    method: 'post',
    data: requestBody
  })
}

// 往来余额_2(优化过后，通过参数控制): 多币种
export function getAccountingEntriesForDealingsBalance2NewByMultiCurrency(requestBody) {
  return request({
    url: URL.finance.accountingEntry.getAccountingEntriesForDealingsBalance2NewByMultiCurrency,
    method: 'post',
    data: requestBody
  })
}

// 往来余额_2: 多币种
export function getAccountingEntriesForDealingsBalance2ByMultiCurrency(requestBody) {
  return request({
    url: URL.finance.accountingEntry.getAccountingEntriesForDealingsBalance2ByMultiCurrency,
    method: 'post',
    data: requestBody
  })
}

// 往来核对账_3，期初，按客户要求，是所有【未完全核销的分录明细】: 多币种
export function getAccountingEntriesForDealingsCheckAccounts3ByMultiCurrency(requestBody) {
  return request({
    url: URL.finance.accountingEntry.getAccountingEntriesForDealingsCheckAccounts3ByMultiCurrency,
    method: 'post',
    data: requestBody
  })
}

// 批量修改辅助核算项目编号
export function batchUpdateAuxiliaryNumbers(requestBody) {
  return request({
    url: URL.finance.accountingEntry.batchUpdateAuxiliaryNumbers,
    method: 'post',
    data: requestBody
  })
}

// 总账_2: 多币种
export function getGeneralLedgerChart2ByMultiCurrency(requestBody) {
  return request({
    url: URL.finance.accountingEntry.getGeneralLedgerChart2ByMultiCurrency,
    method: 'post',
    data: requestBody
  })
}

// 科目余额表_2: 多币种
export function getAccountingTitleBalanceChart2ByMultiCurrency(requestBody) {
  return request({
    url: URL.finance.accountingEntry.getAccountingTitleBalanceChart2ByMultiCurrency,
    method: 'post',
    data: requestBody
  })
}

// 获取明细账日报表的会计日期范围
export function getSubLedgerDailyReportDateRange(params) {
  return request({
    url: URL.finance.accountingEntry.getSubLedgerDailyReportDateRange,
    method: 'get',
    params
  })
}

// 获取明细账日报表的会计日期范围
export function getAccountingEntriesForFlowChart2ByMultiCurrencyDay(requestBody) {
  return request({
    url: URL.finance.accountingEntry.getAccountingEntriesForFlowChart2ByMultiCurrencyDay,
    method: 'post',
    data: requestBody
  })
}

// 刷新是否往来科目+客商+项目编号+币种已核销
export function updatePaidOffFlag(requestBody) {
  return request({
    url: URL.finance.accountingEntry.updatePaidOffFlag,
    method: 'post',
    data: requestBody
  })
}
